export enum OstSubEstadoRawEnum {
  INGRESADO = "INGRESADO",
  EMISION_DE_GUIA = "EMISION_DE_GUIA",
  PRODUCTO_CON_GUIA = "PRODUCTO_CON_GUIA",
  EN_TRANSITO_A_ST = "EN_TRANSITO_A_ST",
  PRODUCTO_EN_ST = "PRODUCTO_EN_ST",
  CON_RESPUESTA_ST = "CON_RESPUESTA_ST",
  PENDIENTE_DE_RETIRO = "PENDIENTE_DE_RETIRO",
  RETORNANDO_A_TIENDA = "RETORNANDO_A_TIENDA",
  PRODUCTO_EN_TIENDA = "PRODUCTO_EN_TIENDA",
  ESPERA_RETIRO_CLIENTE = "ESPERA_RETIRO_CLIENTE",
  GESTION_FINALIZADA = "GESTION_FINALIZADA",
  DAR_SOLUCION_A_CLIENTE = "DAR_SOLUCION_A_CLIENTE",
  EN_PROCESO_EMISION_GC = "EN_PROCESO_EMISION_GC",
  SINIESTRO_TRANSPORTE = "SINIESTRO_TRANSPORTE",
  CANCELAR = "CANCELAR",
  PROBLEMAS_OST = "PROBLEMAS_OST",
  REEMPLAZO_AUTORIZADO = "REEMPLAZO_AUTORIZADO",
  ENTREGADO_A_ASEGURADORA = "ENTREGADO_A_ASEGURADORA",
  PENDIENTE_AGENDAMIENTO_VISITA_TECNICA = "PENDIENTE_AGENDAMIENTO_VISITA_TECNICA",
  VISITA_TECNICA_REALIZADA = "VISITA_TECNICA_REALIZADA",
  VISITA_TECNICA_AGENDADA = "VISITA_TECNICA_AGENDADA",
  PENDIENTE_DE_RETIRO_ASEGURADORA = "PENDIENTE_DE_RETIRO_ASEGURADORA",
}
